import { GENERAL_GOAL_OPTIONS, GeneralGoal, ToneOfVoice, VALID_TONES } from '@mondaygpt/constants'

const VALID_GOALS = new Set<string>(GENERAL_GOAL_OPTIONS.map(g => g.id))

/**
 * Cap auto-suggested tones / goals so the brand card lands with a focused
 * starting point rather than every detected option pre-checked. The picker
 * itself has no max — users can add more after onboarding.
 */
const MAX_SUGGESTED = 3

export function normalizeTones(raw: string[] | undefined): ToneOfVoice[] {
  if (!raw?.length) return []
  const allowed = new Set<string>(VALID_TONES)
  const seen = new Set<ToneOfVoice>()
  raw.forEach(t => {
    const lower = t.toLowerCase().trim() as ToneOfVoice
    if (allowed.has(lower)) seen.add(lower)
  })
  return [...seen].slice(0, MAX_SUGGESTED)
}

export function normalizeGoals(raw: string[] | undefined): GeneralGoal[] {
  if (!raw?.length) return []
  const seen = new Set<GeneralGoal>()
  raw.forEach(g => {
    const lower = g.toLowerCase().trim()
    if (VALID_GOALS.has(lower)) seen.add(lower as GeneralGoal)
  })
  return [...seen].slice(0, MAX_SUGGESTED)
}
